/// <reference path="../../typings/index.d.ts"/>

import * as React from "react";
import * as ReactDOM from "react-dom";
import { Button } from '../components/Button';

export interface LoginPanelProps extends React.Props<LoginPanel> {
    className?: string;
    showLogin: boolean;
    onLogin: any;
}

export interface LoginPanelState {
    version?: string;
    hasActivated?: boolean;
    position?: any;
    user?: any;
    locale?: any;
    database?: any;
}

const w = window;

export class LoginPanel extends React.Component<LoginPanelProps, LoginPanelState> {
    constructor(props: LoginPanelProps) {
        super(props);
        this.state = {
            hasActivated: false,
            position: null,
            user: null,
            locale: null,
            database: w.firebase.database()
        }
    }

    public render() {
        return (
            <div className={"loginpanel " + (this.props.showLogin ? "":"hidden")}>
                <LoginSection title="Step 1 - Login with Google">
                    <Button className="loginsection__button" onClick={this.login.bind(this)} caption="Connect" />
                </LoginSection>

                <LoginSection className={this.state.user ? "":"hidden"} title="Step 2 - Set your status">
                    <input className="loginsection__input" ref="status" type="text" placeholder="Type your status"/>
                </LoginSection>

                <div id="webcam" className={"loginpanel__webcam" + (this.state.user ? "":"hidden")}/>
                <img ref="process" className="loginpanel__process"/>
                <canvas ref="canvas" className="loginpanel__canvas" width="72" height="72"/>
                <img ref="preview" className="loginpanel__preview"/>
                <div ref="map" className="loginpanel__map"/>
            </div>
        )
    }

    public componentWillReceiveProps(props) {
        return props;
    }

    private login() {
        // var provider = new w.firebase.auth.TwitterAuthProvider();
        var provider = new w.firebase.auth.GoogleAuthProvider();
        w.firebase.auth().signInWithPopup(provider).then(function(result) {
            var token = result.credential.accessToken;
            var secret = result.credential.secret;
            var user = result.user;

            this.setState({
                user: user
            });
            this.activate();
            this.props.onLogin(user);
        }.bind(this)).catch(function(error) {
           var errorCode = error.code;
           var errorMessage = error.message;
           var email = error.email;
           var credential = error.credential;
        });
    }

    private activate() {
        if (this.state.hasActivated) {
            return null;
        }
        this.setState({
            hasActivated: true
        });
        this.getLocation();

        w.Webcam.set({
            width: 96,
            height: 72,
            crop_width: 72,
            crop_height: 72,
            jpeg_quality: 100
        });
        w.Webcam.attach('#webcam');
        w.Webcam.setSWFLocation("/externals/webcam/webcam.swf");
        w.Webcam.on('live', () => {
            setInterval(() => {
              this.snap();
              this.record()
          }, 100);
        });
    }

    private getLocation() {
        if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition(function(position) {
                this.setState({
                    position: position
                });
                let latitude = position.coords.latitude;
                let longitude = position.coords.longitude;

                let coords  = new w.google.maps.LatLng(latitude,longitude);
                let map = new w.google.maps.Map(ReactDOM.findDOMNode(this.refs.map), {
                    center: coords,
                    zoom: 15,
                    disableDefaultUI: true,
                    zoomControl: false,
                    scrollwheel: false,
                    draggable: false,
                });
                var marker = new w.google.maps.Marker({
                    position: coords,
                    map: map,
                    title: 'Me'
                });

                let service = new w.google.maps.places.PlacesService(map);

                let request = {
                    location: coords,
                    radius: '10',
                    types: ['point_of_interest']
                };
                service.nearbySearch(request, (data) => {
                    if (data.length >=1) {
                        this.setState({
                            locale: data[data.length-1].name
                        });
                    }
                });
            }.bind(this));
        }
    }

    private record() {
        if (this.state.user) {
            let preview = this.refs['preview'];
            let latitude = this.state.position ? this.state.position.coords.latitude:null
            let longitude = this.state.position ? this.state.position.coords.longitude:null
            this.state.database.ref('users/' + this.state.user.uid).set({
                uid: this.state.user.uid,
                displayName: this.state.user.displayName,
                src: preview['src'],
                latitude: latitude,
                longitude: longitude,
                status: ReactDOM.findDOMNode(this.refs['status'])['value'],
                locale: this.state.locale
            });
        }
    }

    private snap() {
        let process = this.refs['process'];
        let preview = this.refs['preview'];

        let canvas = ReactDOM.findDOMNode(this.refs['canvas']);
        canvas['getContext']('2d').drawImage(process,0,0);
        preview['src'] = canvas['toDataURL']('image/jpeg',0.4);;

        let options = {};
        let effect = {
            screen: {
                r: 227,
                g: 45,
                b: 45,
                a: 0.15
            },
            desaturate: 0.8,
            vignette: 0.3,
            lighten: 0.1
        };
        w.Webcam.snap((data) => {
            let img = this.refs['process'];
            img['src'] = data;
            new w.VintageJS(img, options, effect);
        });
    }
}

interface LoginSectionProps extends React.Props<LoginSection> {
    title?: string;
    className?: string;
}

interface LoginSectionState {

}

class LoginSection extends React.Component<LoginSectionProps, LoginSectionState> {
    constructor(props: LoginSectionProps) {
        super(props);
        this.state = {

        }
    }

    public render() {
        return (
            <div className={"loginsection " + this.props.className}>
                <div className="loginsection__title">
                    {this.props.title}
                </div>
                <div className="loginsection__content">
                    {this.props.children}
                </div>
            </div>
        )
    }
}



/** WEBPACK FOOTER **
 ** ./src/components/LoginPanel.tsx
 **/